export type NavigationBtn = {
  name: string;
  icon: string;
  route: string;
  visibleWhen: 'both' | 'loggedOut' | 'loggedIn';
};

/** MEETINGS */

export type Meeting = {
  id?: number;
  startHour: string;
  endHour: string;
  duration: string;
  serviceId: string;
  operatorId: string;
  date: string;
  userId: string;
};

export type CreatedMeeting = Meeting & {
  operator: Operator;
  service: Service;
};

export type Operator = {
  biography?: string;
  email: string;
  name: string;
  specialty: string;
};
export type Service = {
  name: string;
  duration: number;
};

export type MeeetingParam = {
  meetingTxt?: string;
  time?: number;
  percentOperator?: number;
  gmtZone?: string;
  gmtText?: string;
  giftCard: {
    giftCardId?: number;
    isActive?: boolean;
  };
};

export type Review = {
  comment: string;
  rating: number;
  user: User;
};

export type User = {
  file: string;
  name: string;
  email: string;
  lastName: string;
  balance: number;
};

/** WITHDRAW */

export enum WithdrawStatus {
  Pendiente = 'Pendiente',
  Aprobado = 'Aprobado',
  Rechazado = 'Rechazado',
}

export type Withdraw = {
  id: number;
  created_at: string;
  amount: number;
  accountDetails: string;
  status: WithdrawStatus;
  user: User;
};
